// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.semi-popover-wrapper:has(.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-dropdown-iMfmU2) {
  background: #fff;
  border-radius: 6px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-dropdown-iMfmU2 {
  padding: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-dropdown-iMfmU2 .semi-select-option-empty {
  color: #1d1c23;
  justify-content: flex-start;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor {
  cursor: pointer;
  border-radius: 8px;
  padding: 6px 12px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor * {
  cursor: pointer;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor:hover {
  background: rgba(46, 46, 56, .08);
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor:active, .\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor[aria-expanded="true"] {
  background: rgba(46, 46, 56, .12);
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor[aria-disabled="true"] {
  cursor: not-allowed;
  background-color: unset;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor[aria-disabled="true"] * {
  cursor: not-allowed;
  color: rgba(29, 28, 35, .2) !important;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__filter-content-xIJQkT {
  align-items: center;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__filter-label-cqhbgw {
  color: rgba(28, 31, 35, .4);
  flex-shrink: 0;
  padding-right: 8px;
  font-size: 14px;
  font-weight: 600;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-render-JbLmar {
  align-items: center;
  display: flex;
  overflow: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-render-JbLmar .\\------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-text-b1hHdS {
  color: #1c1f23;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__size-small-bzlxe9 {
  font-size: 12px;
  line-height: 14px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__size-default-pXlDMd {
  font-size: 14px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__size-large-nxKjZ_ {
  font-size: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__filter-icon-JPLuk4 {
  margin-bottom: -2px;
  margin-left: 2px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-small-xa6Z4_ {
  border-radius: 6px;
  padding: 5px 4px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-small-xa6Z4_ .\\------packages-components-bot-semi-src-components-ui-select-index-module__filter-icon-JPLuk4 {
  font-size: 12px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-default-rdFvCL {
  border-radius: 8px;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__light-ui-select-Wl3d0D:not(.semi-select-disabled) div {
  color: #1d1c23;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__light-ui-select-Wl3d0D:not(.semi-select-disabled) span:not(.semi-select-selection-placeholder) {
  color: #1d1c23;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw {
  word-break: break-word;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color var(--semi-transition_duration-none) var(--semi-transition_function-easeIn) var(--semi-transition_delay-none);
  color: #1d1c23;
  border-radius: 4px;
  flex-wrap: nowrap;
  align-items: center;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  position: relative;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw .\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-icon-K9aG0D {
  color: rgba(0, 0, 0, 0);
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-selected-Y2IzEJ {
  font-weight: 600;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-selected-Y2IzEJ .\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-icon-K9aG0D {
  color: #4d53e8;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-disabled-WuFoDu {
  cursor: not-allowed;
  color: rgba(29, 28, 35, .2);
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-disabled-WuFoDu:hover {
  background: none;
}

.\\------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw:hover {
  background: rgba(46, 46, 56, .08);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-select-dropdown": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-dropdown-iMfmU2`,
	"uiSelectDropdown": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-dropdown-iMfmU2`,
	"borderless-ui-select": `------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor`,
	"borderlessUiSelect": `------packages-components-bot-semi-src-components-ui-select-index-module__borderless-ui-select-VJpzor`,
	"filter-content": `------packages-components-bot-semi-src-components-ui-select-index-module__filter-content-xIJQkT`,
	"filterContent": `------packages-components-bot-semi-src-components-ui-select-index-module__filter-content-xIJQkT`,
	"filter-label": `------packages-components-bot-semi-src-components-ui-select-index-module__filter-label-cqhbgw`,
	"filterLabel": `------packages-components-bot-semi-src-components-ui-select-index-module__filter-label-cqhbgw`,
	"borderless-filter-render": `------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-render-JbLmar`,
	"borderlessFilterRender": `------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-render-JbLmar`,
	"borderless-filter-text": `------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-text-b1hHdS`,
	"borderlessFilterText": `------packages-components-bot-semi-src-components-ui-select-index-module__borderless-filter-text-b1hHdS`,
	"size-small": `------packages-components-bot-semi-src-components-ui-select-index-module__size-small-bzlxe9`,
	"sizeSmall": `------packages-components-bot-semi-src-components-ui-select-index-module__size-small-bzlxe9`,
	"size-default": `------packages-components-bot-semi-src-components-ui-select-index-module__size-default-pXlDMd`,
	"sizeDefault": `------packages-components-bot-semi-src-components-ui-select-index-module__size-default-pXlDMd`,
	"size-large": `------packages-components-bot-semi-src-components-ui-select-index-module__size-large-nxKjZ_`,
	"sizeLarge": `------packages-components-bot-semi-src-components-ui-select-index-module__size-large-nxKjZ_`,
	"filter-icon": `------packages-components-bot-semi-src-components-ui-select-index-module__filter-icon-JPLuk4`,
	"filterIcon": `------packages-components-bot-semi-src-components-ui-select-index-module__filter-icon-JPLuk4`,
	"ui-select-small": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-small-xa6Z4_`,
	"uiSelectSmall": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-small-xa6Z4_`,
	"ui-select-default": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-default-rdFvCL`,
	"uiSelectDefault": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-default-rdFvCL`,
	"light-ui-select": `------packages-components-bot-semi-src-components-ui-select-index-module__light-ui-select-Wl3d0D`,
	"lightUiSelect": `------packages-components-bot-semi-src-components-ui-select-index-module__light-ui-select-Wl3d0D`,
	"ui-select-option": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw`,
	"uiSelectOption": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-nhtcVw`,
	"ui-select-option-icon": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-icon-K9aG0D`,
	"uiSelectOptionIcon": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-icon-K9aG0D`,
	"ui-select-option-selected": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-selected-Y2IzEJ`,
	"uiSelectOptionSelected": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-selected-Y2IzEJ`,
	"ui-select-option-disabled": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-disabled-WuFoDu`,
	"uiSelectOptionDisabled": `------packages-components-bot-semi-src-components-ui-select-index-module__ui-select-option-disabled-WuFoDu`
};
export default ___CSS_LOADER_EXPORT___;
